import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button
} from 'reactstrap';
import { BsClipboard } from 'react-icons/bs';

const K3ModalViewSource = ({ isOpen, toggle, source }) => {
  const copyToClipboard = () => {
    navigator.clipboard.writeText(source);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Source Code</ModalHeader>
      <ModalBody>
        <div style={{ position: 'relative' }}>
          <Button 
            color="link" 
            style={{ position: 'absolute', right: 0, top: 0 }}
            onClick={copyToClipboard}
          >
            <BsClipboard size={20} />
          </Button>
          <pre style={{ 
            backgroundColor: '#f8f9fa', 
            padding: '1rem',
            borderRadius: '4px',
            overflow: 'auto',
            maxHeight: '70vh'
          }}>
            {source}
          </pre>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default K3ModalViewSource; 